/*******************************
 *  --window-height CSS variable
 ******************************/

function calculateWindowHeight() {
  document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px')
}
calculateWindowHeight()

window.addEventListener('resize', () => {
  requestAnimationFrame(() => {
    calculateWindowHeight()
  })
})

/*******************************
 *  --scrollbar-width CSS variable
 ******************************/

function calculateScrollbarWidth() {
  // There are edge-casey situations on mobile (related to initial zoom)
  // where the outer width is smaller than the inner width
  const windowWidth = Math.min(window.innerWidth, window.outerWidth)

  // It has been observed in Chrome that the difference between window width and body width
  // became a negative number (in some cases way beyond -1000px), so we take that into account
  const scrollbarWidth = Math.max(windowWidth - document.body.clientWidth, 0)

  document.documentElement.style.setProperty(
    '--scrollbar-width',
    Math.max(scrollbarWidth, 0) + 'px',
  )
}
calculateScrollbarWidth()

// Observe the body width to recalculate scrollbar width
let oldWidth = 0
const observer = new ResizeObserver(([{ contentRect }]) => {
  if (oldWidth === contentRect.width) return
  if (contentRect.width === 0) return

  oldWidth = contentRect.width

  calculateScrollbarWidth()
})
observer.observe(document.body)

// In some cases of window resizing, the body reports before scrollbar size is re-calculated
window.addEventListener('resizeEnd', calculateScrollbarWidth)
